import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { formatNumberWithDecimals } from '@/finsight/ui/components/deals/helpers';
import ITranch from '@/finsight/domain/vo/Tranch/ITranch';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getTranchePrice = (tranche: ITranch): string | number => {
  let price = null;

  if (tranche.retained === true || tranche.interestOnly === true) {
    if (tranche.retained === true) {
      price = 'Retained';
    }

    if (tranche.interestOnly === true) {
      if (tranche.retained === true) {
        price += '; Int. Only';
      } else {
        price = 'Int. Only';
      }
    }
  } else if (tranche.issuePrice && tranche.issuePrice !== '0.000000') {
    price = formatNumberWithDecimals(tranche.issuePrice, 5);
  } else if (!tranche.issuePrice || tranche.issuePrice === '0.000000') {
    price = '-';
  }

  return price;
};

const getCell = ({ row: tranche }: ITranchRow) => getTranchePrice(tranche);

const PriceCell = ({
  rowIndex,
  tranche,
}: ICellProps) => (
  <BodyCell
    name="PriceCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ getCell }
  />
);

export default PriceCell;
